import gql from 'graphql-tag';

export const sanctionedPlateContactsQuery = gql`
	query SanctionedPlateContacts($installationId: ID!) {
		contacts(installationId: $installationId, type: SANCTIONED_PLATE) {
			id
			name
		}
	}
`;

export const installationPinpadEnabledQuery = gql`
	query InstallationPinpadEnabled($installationId: ID!) {
		installationPinpadEnabled(installationId: $installationId)
	}
`;

export const sanctionedPlatesByInstallationQuery = gql`
	query SanctionedPlatesByInstallation($installationId: ID!, $page: Int!, $pageSize: Int!, $search: String) {
		sanctionedPlatesByInstallation(
			installationId: $installationId
			page: $page
			pageSize: $pageSize
			search: $search
			orderBy: label_ASC
		) {
			total
			page
			pageSize
			totalPages
			items {
				id
				plate
				label
				isEnabled
				isVip
				vipContactId
				vipContacts {
					contactId
					contact {
						id
						name
					}
				}
				lot {
					id
					name
				}
				pinpadAccess {
					id
					status
					pin
					validFrom
					validTo
					lastError
				}
			}
		}
	}
`;

export const createSanctionedPlateQuery = gql`
	mutation CreateSanctionedPlate($input: SanctionedPlateCreateInput!) {
		createSanctionedPlate(sanctionedPlate: $input) {
			id
			plate
			label
			isEnabled
			isVip
			vipContacts {
				contactId
				contact {
					id
					name
				}
			}
		}
	}
`;

export const updateSanctionedPlateQuery = gql`
	mutation UpdateSanctionedPlate($input: SanctionedPlateUpdateInput!) {
		updateSanctionedPlate(sanctionedPlate: $input) {
			id
			plate
			isVip
			vipContacts {
				contactId
				contact {
					id
					name
				}
			}
		}
	}
`;

export const deleteSanctionedPlateQuery = gql`
	mutation DeleteSanctionedPlate($id: ID!) {
		deleteSanctionedPlate(id: $id) {
			id
		}
	}
`;
